import * as React from 'react'

import styled from '@theme/styled-components'
import Theme from '@theme/Theme'
import useI18n from '@store/i18n/useI18n'

import Select from 'react-select'

interface Props {
  options: Option[]
  selected?: Option
  setSelected: (option?: Option) => void
  placeholder: string
  isDisabled?: boolean
  isLoading?: boolean
  isClearable?: boolean
  noMargin?: boolean
  bordered?: boolean
  error?: string
}

const Picker = ({
  options,
  selected,
  setSelected,
  placeholder,
  isDisabled,
  isLoading,
  isClearable = true,
  noMargin,
  bordered,
  error,
}: Props) => {
  const i18n = useI18n()

  const [selectOpen, setSelectOpen] = React.useState<boolean>(false)

  return (
    <>
      <Container noMargin={noMargin}>
        <PickerContainer
          selectOpen={selectOpen}
          value={selected || null}
          defaultValue={selected}
          onChange={setSelected}
          options={options}
          placeholder={placeholder}
          noOptionsMessage={() => <>{i18n.t('components.select.noResult')}</>}
          styles={{
            option: (provided: any, state: any) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? Theme.colors.filterPrimaryBackground
                : state.isFocused
                ? Theme.colors.filterSecondaryBackground
                : 'none',
            }),
          }}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isClearable={isClearable}
          onMenuOpen={() => setSelectOpen(true)}
          onMenuClose={() => setSelectOpen(false)}
          bordered={bordered}
        />
        {error && <ErrorLibelle>{error}</ErrorLibelle>}
      </Container>
      {selectOpen && <Background />}
    </>
  )
}

export default Picker

const Container = styled('div')<{ noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${(props) => !props.noMargin && 'margin: 5px 20px;'}
`
const PickerContainer = styled(Select)<{ selectOpen: boolean; bordered?: boolean }>`
  ${(props) => props.selectOpen && 'z-index: 2;'}
  & > div {
    cursor: pointer;
    min-height: 50px;
    background: #ffffff;
    border: ${(props) => (props.bordered ? '2px solid red' : '1px solid #919191')};
    box-sizing: border-box;
    border-radius: 7px;
    & > div {
      cursor: pointer;
      & > span {
        display: none;
      }
      & > div {
        cursor: pointer;
        ${(props) => props.theme.fonts.selectLibelle}
        & > svg {
          color: ${(props) => props.theme.colors.filterPrimarycolor};
        }
        & > div {
          & > div {
          }
        }
      }
    }
  }
`

const Background = styled('div')`
  background-color: ${(props) => props.theme.colors.backgroundColor};
  position: absolute;
  cursor: pointer;
  z-index: 1;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`
const ErrorLibelle = styled('div')`
  ${(props) => props.theme.fonts.errorLibelle};
  text-align: center;
  margin-top: 10px;
`
